import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import ViewModal from "../../../components/commonComponent/ViewModal";
import useModal from "../../../hooks/useModal";
import "../../../styles/SolarStation.css";
import { deleteData, fetchData, getCurrentData } from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;

const columns = [
  { header: "Title", accessor: "title" },
  { header: "Description", accessor: "description" },
];

const ITEMS_PER_PAGE = 10;

const Blobb = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0); 
  const [error, setError] = useState(null);
  const { loading, showLoader, hideLoader } = useLoader();

  const {
    showDeleteModal,
    showViewModal,
    selectedItem,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();
  const navigate = useNavigate();


  const handleDeleteConfirm = () => {
    deleteData(`${API_URL}/offers/deleteOffer`, selectedItem._id, setError)
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => item._id !== selectedItem._id)
        );
        toast.success("Deleted successfully", { autoClose: 1000 });
      
      })
      .catch((error) => {
        setError(error);
        toast.error("Error deleting data", { autoClose: 1000 });
      });
    handleCloseDeleteModal();
  };


  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(
          `${API_URL}/offers/getAllOffers`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch blogs");
        }
        const result = await response.json();
        setFilteredData(result); 
      } catch (error) {
        setError(error.message);
      }
    };

    fetchBlogs();
  }, [currentPage, searchTerm,handleDeleteConfirm]); 

  if (loading) {
    return <div>Loading...</div>;
  }


  const handleSearch = (searchValue) => {
    if (searchValue.length >= 2) {
      setSearchTerm(searchValue);
      setCurrentPage(1);
    } else if (searchValue.length === 0) {
      setSearchTerm("");
      setCurrentPage(1); 
    }
  };


  const fieldsToShow = {
    Title: "title",
    Description: "description",
    Image: "image",
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <h2 className="capitalize font-bold text-[24px] mb-4">Offers List</h2>

      <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
        <div className="flex items-center">
          <div className="search-filter-container">
            <Search
              searchFields={["title"]}
              onSearch={handleSearch}
            />
          </div>
        </div>

        <Link
          to="/offers/add"
          className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
        >
          Add Offers
        </Link>
      </div>

      <div className="table-container">
        {filteredData && filteredData.length > 0 ? (
          <Table
            columns={columns}
            data={filteredData} 
            showIndex={true}
            currentPage={currentPage}
            itemsPerPage={ITEMS_PER_PAGE}
            onDelete={handleOpenDeleteModal}
            onUpdate={(item) => navigate(`/offers/edit/${item._id}`)}
            onView={handleOpenViewModal}
            actions={{
              showView: true,
              showEdit: true,
              showDelete: true,
            }}
            loading={loading}
          />
        ) : (
          <div>No data available</div>
        )}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />

      <DeleteConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={handleDeleteConfirm}
      />

      <ViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={fieldsToShow}
      />
    </div>
  );
};

export default Blobb;
